$(document).foundation();

$(document).ready(function() {
    setTimeout(function(){
        $("header .section").addClass("visible");
        showSections();
    }, 200);
    
    $('.main-slider').slick({
        fade: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 5000,
        appendArrows: $('.main-arrows'),
        prevArrow: '<button class="prev" tabindex="-1"></button>',
        nextArrow: '<button class="next" tabindex="-1"></button>'
    });

    $('.offers-slider').slick({
        fade: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 3000,
        appendArrows: $('.offers-arrows'),
        prevArrow: '<button class="prev" tabindex="-1"></button>',
        nextArrow: '<button class="next" tabindex="-1"></button>'
    });
    
    $('.home-faq-slider').slick({
        fade: false,
        dots: false,
        autoplay: false,
        autoplaySpeed: 3000,
        appendArrows: $('.home-faq-arrows'),
        prevArrow: '<button class="prev" tabindex="-1"></button>',
        nextArrow: '<button class="next" tabindex="-1"></button>'
    });
    
    $('.news-slider').slick({
        fade: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 3000,
        appendArrows: $('.news-arrows'),
        prevArrow: '<button class="prev" tabindex="-1"></button>',
        nextArrow: '<button class="next" tabindex="-1"></button>'
    });
    
    $('.people-slider').slick({
        fade: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 3000,
        appendArrows: $('.people-arrows'),
        prevArrow: '<button class="prev" tabindex="-1"></button>',
        nextArrow: '<button class="next" tabindex="-1"></button>'
    });
    
    $('.faq-slider').slick({
        fade: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 3000,
        appendArrows: $('.faq-arrows'),
        prevArrow: '<button class="prev" tabindex="-1"></button>',
        nextArrow: '<button class="next" tabindex="-1"></button>'
    });
    
    $('.offer-slider').slick({
        fade: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 3000,
        appendArrows: $('.offer-arrows'),
        prevArrow: '<button class="prev" tabindex="-1"></button>',
        nextArrow: '<button class="next" tabindex="-1"></button>'
    });

    $(".hamburger").click(function(e) {
        e.preventDefault();

        if( $(this).hasClass("collapsed") ) {
            $(this).removeClass("collapsed");
            $(".down-menu").hide();
        } else {
            $(this).addClass("collapsed");
            $(".down-menu").show();
        }
    });


    $('.go-back').on('click', function() {
        window.history.back();
    });

    $('.scroll-to').on('click', function(){
        $("html, body").animate({ scrollTop: $($(this).data('anchor')).offset().top }, 1000);
    });

    $('.map').each(function(index, value){
        var mapId = $(this).attr('id');
        initMap(mapId);
    });


    $('.faq-question').on('click', function() {
        $('.faq-slider').slick('slickGoTo', $(this).data('slide'));
        $("html, body").animate({ scrollTop: $('#faq-slider').offset().top }, 500);
    });

    if( $("#field_200tg").length ) {
        $("#field_200tg").attr("type", "hidden").val("");
    }

    if( $("#offer-code").length ) {
        $("#field_200tg").val($("#offer-code").html());
    }

    $(".share-wraper").hover(function(){
        $(".fly", this).each(function(i, el) {
            setTimeout(function() {
                $(el).addClass("visible");
            }, i*80);
        });
    }, function() {
        $(".fly", this).each(function(i, el) {
            setTimeout(function() {
                $(el).removeClass("visible");
            }, i*80);
        });
    });
    
    var sort_data = {};
    $(".offer-cat").click(function(e) {
        e.preventDefault();
        var _this = this;
        var active = $(this).hasClass('active');

        $(".offers-loader").show();

        if( $(this).hasClass('date') ) {
            $(".offer-cat.date.active").removeClass("active");
            delete sort_data.date;

            if( !active ) {
                sort_data.date = $(this).data('order');
                $(this).addClass("active");
            }
        }       
        
        if( $(this).hasClass('price') ) {
            $(".offer-cat.price.active").removeClass("active");
            delete sort_data.price;

            if( !active ) {
                sort_data.price = $(this).data('order');
                $(this).addClass("active");
            }
        }      
        
        if( $(this).hasClass('lang') ) {
            $(".offer-cat.lang.active").removeClass("active");
            delete sort_data.lang;

            if( !active ) {
                sort_data.lang = $(this).data('order');
                $(this).addClass("active");
            }
        } 

        console.log(sort_data);

        $.ajax({
            url: "http://projekty.mda.pl/laxocare/wp-json/laxcare-api/v1/offers",
            type : 'post',
            dataType: 'html',
            data : {
                sort : sort_data
            },
            success : function( response ) {
                $(".offers-wraper .offers-list").html(response);
                $(".offers-loader").hide();
            }
        });
    });
    
    $(".news-cat").click(function(e) {
        e.preventDefault();
        var _this = this;

        $(".news-loader").show();

        $(".news-cat.active").removeClass("active");
        $(this).addClass("active");

        $.ajax({
            url: ajax.url,
            type : 'post',
            dataType: 'html',
            data : {
                action: "filter_news",
                category : $(_this).data("cat")
            },
            success : function( response ) {
                $(".news-wraper .news-list").html(response);
                $(".news-loader").hide();
            }
        });
    });
    
    $(".blog-cat").click(function(e) {
        e.preventDefault();
        var _this = this;

        $(".blog-loader").show();

        $(".blog-cat.active").removeClass("active");
        $(this).addClass("active");

        $.ajax({
            url: ajax.url,
            type : 'post',
            dataType: 'html',
            data : {
                action: "filter_blog",
                category : $(_this).data("cat")
            },
            success : function( response ) {
                $(".blog-wraper .blog-list").html(response);
                $(".blog-loader").hide();
            }
        });
    });

    $(".js-learning-cat").click(function(e) {
        e.preventDefault();
        var _this = this;

        $(".blog-loader").show();

        $(".js-learning-cat.active").removeClass("active");
        $(this).addClass("active");

        $.ajax({
            url: ajax.url,
            type : 'post',
            dataType: 'html',
            data : {
                action: "filter_learning",
                category : $(_this).data("cat")
            },
            success : function( response ) {
                $(".blog-wraper .blog-list").html(response);
                $(".blog-loader").hide();
            }
        });
    });
    
    $(".sitter-cat").click(function(e) {
        e.preventDefault();
        var _this = this;

        $(".sitter-loader").show();

        $(".sitter-cat.active").removeClass("active");
        $(this).addClass("active");

        $.ajax({
            url: ajax.url,
            type : 'post',
            dataType: 'html',
            data : {
                action: "filter_sitter",
                category : $(_this).data("cat")
            },
            success : function( response ) {
                $(".sitter-wraper .sitter-list").html(response);
                $(".sitter-loader").hide();
            }
        });
    });

    if( $(".frm_checkbox").length ) {
        $(".frm_checkbox input").wrap('<span class="custom-checkbox"></span>');
    }

    $(".frm_checkbox label").click(function(e) {
        var checkbox = $(this).parent().find(".custom-checkbox");
        $(checkbox).toggleClass("active");
    });

    $(".frm_checkbox").click(function() {
        $(".custom-checkbox", this).toggleClass("active");
    });
    
    $('.consent-close').on('click', function() {
        $('.consent-reveal').foundation('close');
    });
});

$( window ).scroll(function() {
    showSections();
});

function showSections() {
    var i = 1;
    
    if( !$(".apply-form-fixed-wraper").hasClass("visible") ) {
        setTimeout(function() {
            $(".apply-form-fixed-wraper").addClass("visible");
        }, 1000);
    }

    $(".row").each(function(j, row_el) {
        if( !$(this).hasClass("visible") && $(".section", this).length && $( window ).scrollTop() + $( window ).height() > $(this).offset().top + 50 ) {
            i++;
            $(this).addClass("visible");
            $(".section", this).each(function(k, section_el) {
                setTimeout(function() {
                    $(section_el).addClass("visible");
                    setTimeout(function() {
                        $(".bump, .bam, .siu, .ziu", section_el).each(function(m, bump_el) {
                            setTimeout(function() {
                                $(bump_el).addClass("visible");
                            }, m*80);
                        });
                    }, 500);
                }, i * 300);
            });
        }
    });

    // if(".main-slider-wraper:not(.visible)") {
    //     i++;
    //     setTimeout(function(){
    //         $(".main-slider-wraper").addClass("visible");
    //         $(".search-cont").addClass("visible");  

    //         setTimeout(function(){
    //             $(".apply-form-fixed-wraper").addClass("visible");
    //             $('.main-slider').slick({
    //                 fade: false,
    //                 dots: false,
    //                 autoplay: true,
    //                 autoplaySpeed: 3000,
    //                 appendArrows: $('.main-arrows'),
    //                 prevArrow: '<button class="prev" tabindex="-1"></button>',
    //                 nextArrow: '<button class="next" tabindex="-1"></button>'
    //             });
    //         }, 500);
    //     }, 500);
    // }

    // if(".section:not(.visible)") {
    //     if( $( window ).scrollTop() + $( window ).height() > $(".video.section").offset().top + 50 ) {
    //         i++;
    //         setTimeout(function(){
    //             $(".video.section").addClass("visible");
    //         }, i * 500);
    //     }
    // }

        // if( $(".section:not(.visible)"), this ) {
        //     var section = $(this);
            
        //     if( $( window ).scrollTop() + $( window ).height() > section.offset().top + 50 ) {
        //         setTimeout(function() {
        //             section.addClass("visible");
        //         }, ++i * 500);
        //     }
        // }
        // });
}


function initMap(mapId) {
    var latlngs = [];

    $('.latlng_' + mapId.replace('#', '')).each(function(index, value) {
        latlngs.push({'lat': $(this).data('lat'), 'lng': $(this).data('lng'), 'html': $(this).data('html') });
    });
    
    var map = new google.maps.Map(document.getElementById(mapId), {
        zoom: 7,
        center: latlngs[0],
        styles: [{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#444444"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2f2f2"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.business","elementType":"geometry.fill","stylers":[{"visibility":"on"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#b4d4e1"},{"visibility":"on"}]}]
    });

    map.markers = [];

    latlngs.forEach(function(value, index) {

        var latlng = new google.maps.LatLng( value.lat, value.lng );
        
        var marker = new google.maps.Marker({
            position: latlng,
            map: map,
            icon: themePath + '/img/pin.png'
        });

        var infowindow = new google.maps.InfoWindow({
			content		: value.html
		});

		// show info window when marker is clicked
		google.maps.event.addListener(marker, 'click', function() {

			infowindow.open( map, marker );

		});

        map.markers.push(marker);
    
    });
    
}